<template>
	<nav
		:class="settings.variants[variant].wrapper"
		:aria-label="`Navigation ${id}`"
	>
		<slot />
	</nav>
</template>

<script setup>
import {provide} from 'vue';
import {defineSettings} from '../composables/component';
import {useId} from '#imports';

const settings = defineSettings('NkNav');
const id = useId();

const props = defineProps({
	variant: {
		type: String,
		required: false,
		default: 'default',
	},
	/**
	 * Overwrites the icon of the current variant
	 */
	appendIcon: {
		type: String,
		required: false,
		default: null,
	},
	/**
	 * Overwrites the icon of the current variant
	 */
	prependIcon: {
		type: String,
		required: false,
		default: null,
	},
});

provide('props', props);
</script>
